<template>
  <section class="mfe-section">
    <MyTablesList />
  </section>
</template>

<script>
import MyTablesList from '@/components/MyTables/MyTablesList';

export default {
  name: 'MyTablesMfe',
  components: {
    MyTablesList
  }
};
</script>
